/**
 * Live per-pass progress for the async extract job (2026-08-07).
 *
 * The backend reports {passes: {<pass_name>: 'running'|'done'}} on every
 * poll; this maps it to the Progress bar + caption on
 * CustomerOnboardingPage. The bar owns the 60-95% band of the page's
 * upload→prepare→analyse progress display (25/50 belong to the earlier
 * Docling + prepare steps).
 */

export const EXTRACT_PASS_LABELS = {
  pass_1_inventory: 'inventory',
  pass_2a_locations: 'locations',
  pass_2_contacts: 'contacts',
  pass_3_configurations: 'configurations',
  pass_4_passwords: 'passwords',
  pass_5_flex_assets: 'flex assets',
  pass_6_summary: 'summary',
};

export const EXTRACT_TOTAL_PASSES = 7;

const BASE_PERCENT = 60;
const BAND_PERCENT = 35; // 60 → 95 across the 7 passes

/**
 * @param {?{passes: Object<string, string>}} progress
 * @returns {{done: number, total: number, running: string[], percent: number, caption: string}}
 */
export function summariseExtractProgress(progress) {
  const passes = (progress && progress.passes) || {};
  const done = Object.values(passes).filter((s) => s === 'done').length;
  const running = Object.entries(passes)
    .filter(([, s]) => s === 'running')
    .map(([name]) => EXTRACT_PASS_LABELS[name] || name);
  const percent = Math.min(
    BASE_PERCENT + BAND_PERCENT,
    BASE_PERCENT + Math.round((done / EXTRACT_TOTAL_PASSES) * BAND_PERCENT),
  );
  let caption;
  if (done === 0 && running.length === 0) {
    caption = 'Starting extraction…';
  } else {
    caption = `${done}/${EXTRACT_TOTAL_PASSES} passes complete`
      + (running.length ? ` — extracting: ${running.join(', ')}` : '');
  }
  return { done, total: EXTRACT_TOTAL_PASSES, running, percent, caption };
}
